import React from 'react';
import HeaderPanel from 'ff/debrief/layouts/HeaderPanel';
import Typography from '@mui/material/Typography';

interface Props {}

const Header: React.FC<Props> = props => {
    return (
        <HeaderPanel>
            <Typography variant="h1" color="#F9F9F9">
                Track Logs
            </Typography>
        </HeaderPanel>
    );
};

export default Header;
